import { render, staticRenderFns } from "./ServeJoinsOrder.vue?vue&type=template&id=d574bfbe&scoped=true"
import script from "./ServeJoinsOrder.vue?vue&type=script&lang=js"
export * from "./ServeJoinsOrder.vue?vue&type=script&lang=js"
import style0 from "./ServeJoinsOrder.vue?vue&type=style&index=0&id=d574bfbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d574bfbe",
  null
  
)

export default component.exports